module.exports = __webpack_public_path__ + "static/media/payment_methods_desktop.31d2f44c.svg";